import { config } from './constant';

export const ZAKAT_LOGO = config.BASE_S3_URL + 'logo.png';
export const ZAKAT_LOGO_BIG = config.BASE_S3_URL + '/logo-big.png';
export const MOSQUE_BG = config.BASE_S3_URL + 'mosk.png';
export const MOSQUE_HEADER_BG = config.BASE_S3_URL + 'mosk-header-bg.png';
export const RightImg = config.BASE_S3_URL + 'kaffrah.png';
export const PRAYER = config.BASE_S3_URL + 'prayer.png';
export const FIDYAH_PRAYER = config.BASE_S3_URL + 'fidyah-prayer.png';
export const LOGO_250x250 = config.BASE_S3_URL + 'logo-250x250.png';
export const LOGO_250x249 = config.BASE_S3_URL + 'logo-250x249.png';
export const ZAKAT_LOGO_250x250 = config.BASE_S3_URL + 'zakat-logo-250x250.png';
export const LOGO_OUR_MASJID_60x76 = config.BASE_S3_URL + 'logo-our-masjid-65x76.png';
export const LOGO_OUR_MASJID_FOOTER_442x228 = config.BASE_S3_URL + 'ourmasjid-footer-logos-442x228.png';
export const NOT_REGISTERED_WARNING = config.BASE_S3_URL + 'not-registered-warning.png';
export const RECEIVE_RECEIPT = config.BASE_S3_URL + 'receive-receipt.jpg';
export const QR_CODE_PAYNOW_FADED = config.BASE_S3_URL + 'paynow-qr-code-faded.png';
export const QR_DUMMY_SINGPASS = config.BASE_S3_URL + 'qr-dummy.png';
export const ARROW_BACK = config.BASE_S3_URL + 'arrow-back.svg';
export const ARROW_NEXT_WHITE = config.BASE_S3_URL + 'arrow-next-white.svg';
export const TICK_GRAPHIC = config.BASE_S3_URL + 'tick-graphic.svg';
export const TICK_SUCCESS_GRAPHIC = config.BASE_S3_URL + 'tick-success-graphic.svg';
export const ICON_RECEIPT = config.BASE_S3_URL + 'receipt.svg';
export const ENROLE_MANUALLY = config.BASE_S3_URL + 'enrole-manually.svg';
export const AC_VERIFY_PENDING = config.BASE_S3_URL + 'ac-verify-pending.svg';
export const ICON_NOTE = config.BASE_S3_URL + 'note-icon.svg';
export const ICON_WANT_SIGN_IN = config.BASE_S3_URL + 'want-sign-in.svg';
export const MARK_EXCLAMATION = config.BASE_S3_URL + 'exclamation-mark.svg';
export const MARK_EXCLAMATION_17x17 = config.BASE_S3_URL + 'exclamation-mark-17x17.svg';
export const MARK_EXCLAMATION_GREY_17x17 = config.BASE_S3_URL + 'exclamation-mark-gray-17x17.svg';
export const CLOSE_DARK = config.BASE_S3_URL + 'close-dark.svg';
export const ICON_PLUS = config.BASE_S3_URL + 'plus.svg';
export const ICON_MINUS = config.BASE_S3_URL + 'minus.svg';
export const ICON_CIRCLE_MINUS = config.BASE_S3_URL + 'circle-minus.svg';
export const ICON_CLOSE_POPUP = config.BASE_S3_URL + 'popup-close.svg';
export const ICON_CALENDAR = config.BASE_S3_URL + 'calendar.svg';
export const ICON_BACK = config.BASE_S3_URL + 'icon-back.svg';
export const ICON_EDIT = config.BASE_S3_URL + 'icon-edit.svg';
export const ICON_USER_PROFILE_27x27 = config.BASE_S3_URL + 'icon-user-profile-27x27.svg';
export const ICON_USER_PROFILE_30x30 = config.BASE_S3_URL + 'icon-user-profile-30x30.svg';
export const ICON_USER_PROFILE_42x42 = config.BASE_S3_URL + 'icon-user-profile-42x42.svg';
export const DOT_OPTIONS = config.BASE_S3_URL + 'dot-options.svg';
export const CLOSE_RED = config.BASE_S3_URL + 'close-red.svg';
export const CLOSE_SUCCESS_LOGIN = config.BASE_S3_URL + 'login-success-close.svg';
export const TICK_CIRCLE_BIG = config.BASE_S3_URL + 'tick-circle-big.svg';
export const TICK_LOGIN_SUCCESS = config.BASE_S3_URL + 'tick-login-success.svg';
export const TICK_SUCCESS = config.BASE_S3_URL + 'tick-success.svg';
export const ICON_TOOLTIP = config.BASE_S3_URL + 'toooltip.svg';


/** CARD IMAGES - .PNG */
export const CARD_DEFAULT = config.BASE_S3_URL + 'cards/default-195x125.png';
export const CARD_AMERICAN = config.BASE_S3_URL + 'cards/american-express-195x125.png';
export const CARD_DINERS_CLUB = config.BASE_S3_URL + 'cards/diners-club-195x125.png';
export const CARD_JCB = config.BASE_S3_URL + 'cards/jcb-195x125.png';
export const CARD_MASTER_CARD = config.BASE_S3_URL + 'cards/master-card-195x125.png';
export const CARD_UNION_PAY = config.BASE_S3_URL + 'cards/union-pay-195x125.png';
export const CARD_VISA = config.BASE_S3_URL + 'cards/visa-195x125.png';
export const CARD_GOOGLE = config.BASE_S3_URL + 'cards/g-pay.png';
export const CARD_APPLE_PAY = config.BASE_S3_URL + 'cards/apple-pay.png';
export const CARD_ALIPAY = config.BASE_S3_URL + 'cards/alipay.png';
export const CARD_GRABPAY = config.BASE_S3_URL + 'cards/grab-pay.png';
export const CARD_PAYNOW = config.BASE_S3_URL + 'cards/pay-now.png';
export const CARD_CASH = config.BASE_S3_URL + 'cards/cash-195x125.png';
export const CARD_CHEQUE = config.BASE_S3_URL + 'cards/cheque-195x125.png';
export const CARD_NETS = config.BASE_S3_URL + 'cards/nets-195x125.png';
export const CARD_BANK_TRANSFER = config.BASE_S3_URL + 'cards/bank-transfer.png';
export const CARD_NETS_QR_1 = config.BASE_S3_URL + 'cards/nets-qr-1.png';
export const CARD_NETS_QR_2 = config.BASE_S3_URL + 'cards/nets-qr-2.png';


/** CARD IMAGES - .SVG */
export const CARD_GOOGLE_SVG = config.BASE_S3_URL + 'cards/g-pay.svg';
export const CARD_APPLE_PAY_SVG = config.BASE_S3_URL + 'cards/applepay.svg';
export const CARD_ALIPAY_SVG = config.BASE_S3_URL + 'cards/alipay.svg';
export const DOTS_VERTICAL_3 = config.BASE_S3_URL + 'cards/vertical-dots-3.svg';
export const DOTS_HORIZONTAL_3 = config.BASE_S3_URL + 'cards/horizontal-card-dots.svg';
export const CARD_ADD_GRAPHICS = config.BASE_S3_URL + 'cards/add-card-graphic.svg';

/** SOCIAL ICONS */
export const SOCIAL_ICON_FACEBOOK = config.BASE_S3_URL + 'social/share-feature-icons/facebook.png';
export const SOCIAL_ICON_INSTAGRAM = config.BASE_S3_URL + 'social/share-feature-icons/instagram.png';
export const SOCIAL_ICON_LINK = config.BASE_S3_URL + 'social/share-feature-icons/link.png';
export const SOCIAL_ICON_MAIL = config.BASE_S3_URL + 'social/share-feature-icons/mail.png';
export const SOCIAL_ICON_TWITTER = config.BASE_S3_URL + 'social/share-feature-icons/twitter.png';
export const SOCIAL_ICON_WHATSAPP = config.BASE_S3_URL + 'social/share-feature-icons/whatsapp.png';

export const ICON_GOOGLE_G = config.BASE_S3_URL + 'icon-google-g.svg';
export const ICON_FACEBOOK_F = config.BASE_S3_URL + 'icon-facebook-f.svg';

/** CONTACTS - .SVG */
export const CONTACT_ADDRESS = config.BASE_S3_URL + 'contact/address.svg';
export const CONTACT_EMAIL = config.BASE_S3_URL + 'contact/email.svg';
export const CONTACT_TEL = config.BASE_S3_URL + 'contact/tel.svg';

//  wakaf 
export const WAKAF_ILUM_BG = config.BASE_S3_URL + 'wakaf/wakaf-bg.jpg';
export const WAKAF_WMS_BG = config.BASE_S3_URL + 'wakaf/wakaf-wms-bg.jpg';
export const WAKAF_LOGO = config.BASE_S3_URL + 'wakaf/wakaf-logo.png';
export const WAKAF_LOGO_LARGE = config.BASE_S3_URL + 'wakaf/wakaf-logo-large.png';
export const WAKAF_LOGO_BG = config.BASE_S3_URL + 'wakaf/wakaf-logo-bg.png';
export const WAKAF_LOGO_SM = config.BASE_S3_URL + 'wakaf/wakaf-logo-sm.png';
export const WAKAF_MUIS_LOGO = config.BASE_S3_URL + 'wakaf/muis-wakaf-logo.png';
export const RECEIPT_ILMU_LOGO = config.BASE_S3_URL + 'wakaf/receipt-ilmu-logo.png';
export const RECEIPT_WMS_LOGO = config.BASE_S3_URL + 'wakaf/receipt-wms-logo.png';

//  Pledge
export const CROSS_ICON = config.BASE_S3_URL + 'pledge/cross-icon.svg';
export const DOC_ICON = config.BASE_S3_URL + 'pledge/doc-icon.svg';
export const RIGHT_ARROW = config.BASE_S3_URL + 'pledge/right-arrow.svg';
export const UPLOAD_ICON = config.BASE_S3_URL + 'pledge/upload-icon.svg';
export const WASIAT = config.BASE_S3_URL + 'pledge/wasiat.svg';
export const CPF_NOMINATION = config.BASE_S3_URL + 'pledge/Investment-data-rafiki.svg';
export const INSURANCE_NOMINATION = config.BASE_S3_URL + 'pledge/cpf-nomination.svg';

export const WAKAF_WMS_LOGO = config.BASE_S3_URL + 'wakaf/wms_logo.png'; 
export const WAKAF_ILMU_LOGO = config.BASE_S3_URL + 'wakaf/ilmu_logo.png'; 


// Queue Buster 

export const QUEUE_ZAKAT_ICON = config.BASE_S3_URL + 'queue-icons/zakat-icon.png';
export const QUEUE_FIDYAH_ICON = config.BASE_S3_URL + 'queue-icons/fidyah-icon.png';
export const QUEUE_ZAKAT_CALC = config.BASE_S3_URL + 'queue-icons/zakat-calc.png';
export const QUEUE_AI = config.BASE_S3_URL + 'queue-icons/ai-icon.png';
export const SINGPASS_ICON = config.BASE_S3_URL + 'queue-icons/singpass.png';
export const MANUAL_ICON = config.BASE_S3_URL + 'queue-icons/manual.png';
export const CHEQUE_ICON = config.BASE_S3_URL + 'queue-icons/cheque.png';
export const CASH_ICON = config.BASE_S3_URL + 'queue-icons/cash.png';
export const BANK_TRANSFER_ICON = config.BASE_S3_URL + 'queue-icons/bank-transfer.png';
export const DEBIT_NETS_ICON = config.BASE_S3_URL + 'queue-icons/debit-nets.png'; 

// AI CHAT BOT
export const USTAD_IMAGE = config.BASE_S3_URL + 'ai-bot/ustad-images.png'; 
export const USTAD_ICON = config.BASE_S3_URL + 'ai-bot/ustad-icon.png'; 
export const PREDEFINE_ICON1 = config.BASE_S3_URL + 'ai-bot/predefined-icon1.png'; 
export const PREDEFINE_ICON2 = config.BASE_S3_URL + 'ai-bot/predefined-icon2.png'; 
export const PREDEFINE_ICON3 = config.BASE_S3_URL + 'ai-bot/predefined-icon3.png'; 

export const LISTENING_IMG = config.BASE_S3_URL + 'queue-icons/avtar.png';
export const AI_MASK = config.BASE_S3_URL + 'queue-icons/mask-ai-chatbot.png';
export const AMIL_ICON = config.BASE_S3_URL + 'queue-icons/amil-icon.png';


export const Slider_1 = config.BASE_S3_URL + 'slider/slider-1.png';
export const Slider_2 = config.BASE_S3_URL + 'slider/slider-2.png';
export const Slider_3 = config.BASE_S3_URL + 'slider/slider-3.png';
export const Slider_4 = config.BASE_S3_URL + 'slider/slider-4.png';
export const Bg_Logo = config.BASE_S3_URL + 'slider/slider-bg.png';
